/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { networkEconomicsParametersGetApiV3NetworkEconomicsParametersParameter } from "../../funcs/networkEconomicsParametersGetApiV3NetworkEconomicsParametersParameter.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations.GetApiV3NetworkEconomicsParametersParameterRequest$inboundSchema,
};

export const tool$networkEconomicsParametersGetApiV3NetworkEconomicsParametersParameter:
  ToolDefinition<typeof args> = {
    name:
      "network-get-api-v3-economics-parameters-parameter",
    description: `Get network economics parameter by name.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await networkEconomicsParametersGetApiV3NetworkEconomicsParametersParameter(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
